
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "../../store/httpClient";

@Component
export default class Settings extends Vue {
	private loading: boolean = false;
	private messages: string[] = [];
	private log: string = "";
	private currentBroadcastMessage: string = "";
	private newBroadcastMessage: string = "";
	private selectedBroadcastEventType: string = "KundenportalError";
	private isMaintenanceBroadcast: boolean = false;

	private broadcastEventTypes: string[] = ["KundenportalError", "KundenportalInfo"];

	private mounted() {
		this.getBroadcastMessage();
	}

	private get broadcastColor() {
		return this.currentBroadcastMessage.length > 0 ? "orange" : "green";
	}

	private async getBroadcastMessage() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Settings/GetLastBroadcastEvent?eventType=${this.selectedBroadcastEventType}`
			);
			this.currentBroadcastMessage = response.data;
		} catch (err) {
			console.log("Fehler beim Abfragen der aktuellen Broadcast Nachricht.");
		} finally {
			this.loading = false;
		}
	}

	private async saveBroadcastMessage() {
		try {
			this.loading = true;
			const broadcastInfo = {
				eventType: this.selectedBroadcastEventType,
				message: this.currentBroadcastMessage,
				isMaintenance: this.isMaintenanceBroadcast,
			};
			await httpClient().post("Settings/BroadcastMessage", broadcastInfo);
			this.$store.commit("setSnackbarText", "Meldung erfolgreich gespeichert.");
			this.isMaintenanceBroadcast = false;
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Beim Speichern der Meldung ist ein Fehler aufgetreten."
			);
			this.getBroadcastMessage();
		} finally {
			this.loading = false;
		}
	}

	private async deleteBroadcastMessage() {
		this.currentBroadcastMessage = "";
		await this.saveBroadcastMessage();
	}

	private async executeSystemCommand(command: string, confirmMessage?: string) {
		if (confirmMessage && !window.confirm(confirmMessage)) {
			return;
		}
		try {
			this.loading = true;
			await httpClient().post(`System/${command}`);
		} catch {
			console.error("Fehler beim Ausführen eine Systemkommandos");
		} finally {
			this.loading = false;
		}
	}

	private async updateMailChimp() {
		try {
			this.loading = true;
			const response = await httpClient().get(`Customer/UpdateMailChimp`);
			this.messages = response.data;
		} catch {
			console.log("Update MailChimp failed.");
		} finally {
			this.loading = false;
		}
	}

	private async sendInvoices() {
		try {
			this.loading = true;
			await httpClient().post(`CustomerOrder/SendInvoices`);
		} catch {
			console.log("Send invoices failed.");
		} finally {
			this.loading = false;
		}
	}

	private async createInvoices() {
		try {
			this.loading = true;
			await httpClient().post(`CustomerOrder/CreateInvoices`);
		} catch {
			console.log("Create invoices failed.");
		} finally {
			this.loading = false;
		}
	}
}
